export default "__VITE_ASSET__b5cf814e__"